// extracted by mini-css-extract-plugin
export default {"imgContainer":"style_imgContainer__ZfFWE","mainImg":"style_mainImg__O+uBY","disable":"style_disable__h4uwk"};